import React from 'react';
import { MdThumbUp } from 'react-icons/md';

const ReplyItem = ({ reply, onCommentLike, formatTimeAgo }) => {
  const name = reply.comment_user_name || "User";
  const initial = name?.[0]?.toUpperCase() || 'U';

  return (
    <div className="flex gap-3 mt-3">
      <div className="flex-shrink-0">
        {reply.comment_user_profile ? (
          <img
            src={reply.comment_user_profile}
            alt={name}
            className="w-8 h-8 rounded-full object-cover border border-gray-200"
          />
        ) : (
          <div className="w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center text-white font-semibold text-sm border border-gray-200">
            {initial}
          </div>
        )}
      </div>

      <div className="flex-1">
        <div className="bg-gray-50 rounded-2xl p-3">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-1">
              <p className="font-medium text-sm font-semibold text-gray-900 hover:underline hover:text-blue-600 cursor-pointer">
                {name}
              </p>
              {reply?.is_author && (
                <span className="text-xs text-gray-500 bg-gray-100 px-1.5 py-0.5 rounded-full">
                  Author
                </span>
              )}
            </div>
            <span className="text-xs text-gray-500">
              {formatTimeAgo(reply.created_at)}
            </span>
          </div>

          <p className="text-sm text-gray-800 mt-1">
            {reply?.comment || ""}
          </p>

          <div className="flex items-center mt-2 text-xs text-gray-500">
            <button
              className={`flex items-center gap-1 hover:text-blue-600 ${
                reply?.has_liked_comment ? "text-blue-600" : ""
              }`}
              onClick={() => onCommentLike(reply.comment_id, reply.has_liked_comment)}
            >
              <MdThumbUp className={`text-base ${reply.has_liked_comment ? "text-blue-600" : ""}`} />
              {reply?.comment_likes > 0 && (
                <span>{reply.comment_likes}</span>
              )}
              <span>Like</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReplyItem;